import React from 'react'

import { Outlet } from 'react-router-dom'
import { useInitializeAppContext } from 'contexts/app-context/hooks/useInitializeAppContext'
import { useSetPrivacyCenterContent } from 'contexts/app-context/hooks/useSetPrivacyCenterContent'
import { Loader } from 'components/loader'

const AppInitializerWrapper = () => {
  const { isLoading } = useInitializeAppContext()
  useSetPrivacyCenterContent()

  if (isLoading) return <Loader size={45} />
  return <Outlet />
}

export { AppInitializerWrapper }
